<div class="min-h-screen bg-app-canvas">
    <div [ngStyle]="{ 'font-size': fontSize }">
        <header *ngIf="!hideNavigation" class="fixed left-0 right-0 top-0 z-50 flex items-center justify-between border-b border-app-brand-border-soft bg-white px-4 py-3 shadow-nav-top sm:px-6">
            <button class="relative inline-flex h-11 w-11 items-center justify-center rounded-lg border border-app-border bg-app-surface-panel text-app-ink-muted"
                type="button" [class.border-app-brand-border]="sidebarOpen" [class.bg-app-brand-soft]="sidebarOpen" [class.text-app-brand-dark]="sidebarOpen" aria-label="開啟選單" (click)="toggleSideBar()">
                <i class="bi bi-list app-icon text-2xl" aria-hidden="true"></i>
            </button>
            <div class="flex items-center justify-center border-b-[3px] border-app-highlight px-2 pb-1 pt-0.5" aria-label="碧雲莊雲幣 App">
                <img src="/public/icons/icon-48x48.png" alt="" class="h-10 w-10 rounded-lg" aria-hidden="true">
            </div>
            <button type="button"
                class="relative inline-flex h-11 w-11 items-center justify-center rounded-lg border border-app-border bg-app-surface-panel text-app-ink-muted"
                [class.border-app-brand-border]="notificationOpen" [class.bg-app-brand-soft]="notificationOpen" [class.text-app-brand-dark]="notificationOpen" aria-label="開啟通知" (click)="toggleNotificationBar()">
                <i class="bi bi-bell-fill app-icon" aria-hidden="true"></i>
                <span *ngIf="unreadNotificationCount > 0"
                    class="absolute right-1 top-1 h-2.5 w-2.5 rounded-full border-2 border-white bg-app-accent"></span>
            </button>
        </header>
    </div>

    <!-- Main Content Container -->
    <div class="min-w-0 w-full" [ngStyle]="{ 'font-size': fontSize }">
        <main [ngClass]="hideNavigation ? 'pt-0 pb-0' : 'pt-24 pb-32'">
            <router-outlet></router-outlet>
        </main>
    </div>

    <!-- Bottom Navigation Footer -->
    <footer *ngIf="!hideNavigation" class="fixed bottom-0 left-0 right-0 z-40 border-t border-app-brand-border-soft bg-white pb-[env(safe-area-inset-bottom,0px)] shadow-nav-bottom"
        [ngStyle]="{ 'font-size': fontSize }">
        <div class="flex items-center justify-center px-2 py-3 sm:px-4">
            <nav class="grid w-full max-w-xl grid-cols-4 gap-1 sm:gap-3">
                <button class="flex min-w-0 flex-col items-center justify-center rounded-lg px-1 py-2 text-xs text-app-ink-muted disabled:cursor-not-allowed disabled:opacity-50 sm:p-3"
                    [disabled]="isPageLoading" (click)="navigateTo('start')">
                    <i class="bi bi-house-door-fill app-icon mb-1 text-xl" aria-hidden="true"></i>
                    <span class="font-medium">首頁</span>
                </button>
                <button class="flex min-w-0 flex-col items-center justify-center rounded-lg px-1 py-2 text-xs text-app-ink-muted disabled:cursor-not-allowed disabled:opacity-50 sm:p-3"
                    [disabled]="isPageLoading" (click)="navigateTo('category-page')">
                    <i class="bi bi-list-check app-icon mb-1 text-xl" aria-hidden="true"></i>
                    <span class="font-medium">任務</span>
                </button>
                <button class="flex min-w-0 flex-col items-center justify-center rounded-lg px-1 py-2 text-xs text-app-ink-muted disabled:cursor-not-allowed disabled:opacity-50 sm:p-3"
                    [disabled]="isPageLoading" (click)="navigateTo('personal-finance')">
                    <i class="bi bi-wallet2 app-icon mb-1 text-xl" aria-hidden="true"></i>
                    <span class="font-medium">{{ user.is_super_admin ? '金庫' : '錢包' }}</span>
                </button>
                <button class="flex min-w-0 flex-col items-center justify-center rounded-lg px-1 py-2 text-xs text-app-ink-muted disabled:cursor-not-allowed disabled:opacity-50 sm:p-3"
                    [disabled]="isPageLoading" (click)="navigateTo('account')">
                    <i class="bi bi-person-circle app-icon mb-1 text-xl" aria-hidden="true"></i>
                    <span class="font-medium">帳戶</span>
                </button>
            </nav>
        </div>
    </footer>

<!-- Sidebar Component -->
<app-side-bar 
    [isOpen]="sidebarOpen"
    [fontSize]="fontSize"
    [isLogin]="isLogin"
    [user]="user"
    [accountType]="accountType"
    [isCharity]="isCharity"
    [isAdmin]="isAdmin"
    (close)="closeSidebar()"
    (fontSizeChange)="onFontSizeChange($event)"
    (switchAccount)="onSwitchAccount()">
</app-side-bar>

<!-- Notification Bar Component -->
<app-notification-bar
    #notificationBar
    [isOpen]="notificationOpen"
    [fontSize]="fontSize"
    [isLogin]="isLogin"
    [userId]="user.id"
    (close)="closeNotificationBar()"
    (notificationsUpdated)="onNotificationsUpdated($event)">
</app-notification-bar>

<!-- Offline Lock Overlay -->
<div *ngIf="isOffline"
    class="fixed inset-0 z-[10000] flex items-center justify-center bg-slate-950/80 px-6 backdrop-blur-sm"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="offline-lock-title">
    <div class="w-full max-w-sm rounded-lg bg-white p-6 text-center shadow-2xl">
        <div class="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-lg bg-app-accent-soft text-app-accent-dark">
            <i class="bi bi-wifi-off app-icon text-3xl" aria-hidden="true"></i>
        </div>
        <h2 id="offline-lock-title" class="mb-2 text-xl font-semibold text-gray-900">目前沒有網路連線</h2>
        <p class="text-sm leading-6 text-gray-600">請恢復網路後再繼續使用。連線恢復時系統會自動解除鎖定。</p>
    </div>
</div>

<!-- Multi-Device Monitor -->
<!-- <app-multi-device-monitor></app-multi-device-monitor> -->
</div>
